"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = {
  responseConvert: function responseConvert(data) {
    var i, jsDateFormat, key, len, match, mysqlDateFormat, row, value;
    if (!data) {
      // returns on empty results
      return data;
    }

    // works with records and collections
    if (data.constructor === Array) {
      for (key = i = 0, len = data.length; i < len; key = ++i) {
        row = data[key];
        data[key] = this.responseConvert(row);
      }
      return data;
    }
    mysqlDateFormat = /^([0-9]{4}-[0-9]{2}-[0-9]{2}|[0-9]{4}-[0-9]{1,2}-[0-9]{1,2} [0-9]{1,2}:[0-9]{1,2}:[0-9]{1,2})$/;
    jsDateFormat = /^([0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}Z)$/;
    for (key in data) {
      value = data[key];
      if (typeof value === "string" && (match = value.match(mysqlDateFormat))) {
        data[key] = this.stringToDate(match[0]);
      } else if (typeof value === "string" && (match = value.match(jsDateFormat))) {
        data[key] = new Date(match[0]);
      } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
        this.responseConvert(value); //recurse into nest object
      }
    }
    return data;
  },
  stringToDate: function stringToDate(value) {
    var parts;
    parts = value.split(/[^0-9]/);
    if (value === "0000-00-00 00:00:00" || value === "0000-00-00") {
      return '';
    }
    if (parts.length > 5) {
      return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]);
    }
    if (parts.length > 2) {
      return new Date(parts[0], parts[1] - 1, parts[2]);
    }
    return value;
  },
  requestConvert: function requestConvert(data) {
    var d, i, key, len, newobj, row, value;
    // returns on empty results
    return data; //if !data --disabled here for js version

    // works with records and collections
    if (data.constructor === Array) {
      for (key = i = 0, len = data.length; i < len; key = ++i) {
        row = data[key];
        data[key] = this.requestConvert(row);
      }
      return data;
    }
    newobj = {};
    for (key in data) {
      value = data[key];
      if (value instanceof Date) {
        d = value;
        newobj[key] = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
      } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
        this.requestConvert(value); //recurse into nest object
      } else {
        newobj[key] = value;
      }
    }
    return newobj;
  }
};